export const extractDocuments = (data = []) => {
  const results = [];

  data.forEach(item => {
    const jobTitle = item.jobInfo?.jobTitle;
    const jobCode = item.jobInfo?.jobCode;
    const placement = item.clientPlacement?.placement;
    const code = item.permanentPlacement?.consultant?.code;
    const firstName = item.permanentPlacement?.consultant?.firstName;

    const documentSources = [
      { docs: item.clientPlacement?.documents?.placement || [] },
      { docs: item.clientPlacement?.documents?.client || [] },
      { docs: item.permanentPlacement?.documents || [] },
      { docs: item.invoices?.documents || [] }
    ];

    // Process all structured document arrays
    documentSources.forEach(source => {
      source.docs.forEach(doc => {
        results.push({
          jobTitle,
          jobCode,
          placement,
          code,
          firstName,
          doc: [{ ...doc }]
        });
      });
    });

    // Handle poLink if it's an array of file names
    if (Array.isArray(item.poLink)) {
      item.poLink.forEach((poFile, index) => {
        results.push({
          jobTitle,
          jobCode,
          placement,
          code,
          firstName,
          doc: [{
            docType: "PoLink",
            file: [poFile],
            uiid: `po-${index + 1}`,
            addedBy: null,
            addedOn: null,
            updatedAt: null,
            _id: `polink-${index + 1}`,
            ref: {
              entity: "PoLink",
              path: "poLink",
              id: index + 1
            }
          }]
        });
      });
    }
  });

  return results;
};
